import React, { useState, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import { Col, Form, Row } from 'react-bootstrap';
import { Checkbox } from 'primereact/checkbox';
import { responsivePropType } from 'react-bootstrap/esm/createUtilityClasses';


export default function SchoolList(props) {
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editFormVisible, setEditFormVisible] = useState(false);
    const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);

    
    const [currentItem, setCurrentItem] = useState(null);
    const [items, setItems] = useState([]);
    const [filterItems, setFilterItems] = useState([]);
    const LoadingRows = Array.from({length:5});

    const [organizationCode, setOrganizationCode] = useState("");
    const [schoolName, setSchoolName] = useState("");
    const [province, setProvince] = useState("");
    const [city, setCity] = useState("");
    const [address, setAddress] = useState("");
    const [maxStudent, setMaxStudent] = useState();
    const [isAgent, setIsAgent] = useState(false);
    
    const [searchText, setSearchText] = useState("");
    const [includeActive, setIncludeActive] = useState(true);
    const [includeInActive, setIncludeInActive] = useState(true);
    const [agentCode, setAgentCode] = useState(0);

    useEffect(() => {
      reloadData();
    }, []);
    const reloadData = function(){
      setLoading(true);
      
      var user = util.getTrustedUser();
      setIsAgent(user.role == util.UserRoles.Agent);
      var ag = agentCode;
      if(user.role == util.UserRoles.Agent) ag = user.agentCode;
      var params = {login:user, searchText:searchText, agentCode:ag, includeActive:includeActive, includeInActive:includeInActive, lastIndex:0, pageSize:0};
      var url = config.Server+`/basic/school/full/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  console.log("response is>", response);
                  for(var i=0;i<response.length;i++){
                    response[i]["id"] = response[i].school.id;
                  }
                  
                  setItems(response);
                  setFilterItems(response);
                  
                  setLoading(false);
                  
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }

    const addNewItem = function(){
      setCurrentItem(null);
      setCurrentItem("");
      setOrganizationCode("");
      setSchoolName("");
      setProvince("");
      setCity("");
      setAddress("");
      setMaxStudent("");
      setEditFormVisible(true);
    }
    const onRowEditClick = function(row) {
      setCurrentItem(row);
      setOrganizationCode(row.school.organizationCode);
      setSchoolName(row.school.schoolName);
      setProvince(row.school.province);
      setCity(row.school.city);
      setAddress(row.school.address);
      setMaxStudent(row.school.maxStudent);
      setEditFormVisible(true);        
    }
    const onRowDeleteClick = function(row) {
      setCurrentItem(row);
      setConfirmDeleteVisible(true);
    }

    const closeEditDialog = function(){
      setEditFormVisible(false);
    }
    const deleteItem = function(){
      setDeleting(true);
      var id = currentItem.id;
      var params = {login:util.getTrustedUser(), id:id};
      var url = config.Server+`/basic/school/delete`;
        axios
            .post(url, params )
            .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  for(var i=0;i<tmp.length;i++){
                    if(tmp[i].id === id){
                      tmp.splice(i, 1);
                      break;
                    }
                  }
                  setCurrentItem(null);
                  setItems(tmp);
                  setFilterItems(tmp);
                  
                  setDeleting(false);
                  setConfirmDeleteVisible(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setDeleting(false);
              }
            })
            .catch(error => {
              setDeleting(false);
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
            });
    }
    const onDeleteConfirm_Accept = function(){
      deleteItem();
    }
    const onDeleteConfirm_Reject = function(){
        if(deleting) return;
        setConfirmDeleteVisible(false);
    }

    const checkDataEntry = function(){
        if((organizationCode == 0)||(organizationCode == "")||(organizationCode == null)){
            setErrorMessage("کد واحد سازمانی را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(schoolName.trim().length == 0){
            setErrorMessage("نام مدرسه را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(province.trim().length == 0){
            setErrorMessage("استان را وارد کنید");
            setErorVisible(true);
            return false;
        } 
        if(city.trim().length == 0){
            setErrorMessage("شهر را وارد کنید");
            setErorVisible(true);
            return false;
        } 
        if(address.trim().length == 0){
            setErrorMessage("آدرس را وارد کنید");
            setErorVisible(true);
            return false;
        } 
        if((maxStudent == 0)||(maxStudent == "")||(maxStudent == null)){
            setErrorMessage("حداکثر تعداد دانش آموز را وارد کنید");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const saveItem = function(){
      if(!checkDataEntry()) return;

      setSaving(true);
      var id = "";
      var manager={};
      var reg = 0;
      if(currentItem != null){
        id = currentItem.id;
        manager = {...currentItem.manager};
        reg = currentItem.registerdStudent;
      }
      var params = {login:util.getTrustedUser(), id:id, organizationCode:organizationCode, schoolName:schoolName, province:province, city:city, address:address, maxStudent:maxStudent};
      var url = config.Server+`/basic/school/update/detail`;
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data;
                  var tmp = [...items];
                  if(id === ""){
                    tmp.push(response);
                  }
                  else{
                    for(var i=0;i<tmp.length;i++){
                      if(tmp[i].id === id){
                        tmp[i] = {
                          id:id,
                          school:{ 
                            organizationCode:organizationCode,
                            schoolName:schoolName,
                            province:province,
                            city:city,
                            address:address,
                            maxStudent:maxStudent 
                          },
                          registerdStudent : reg,
                          manager:manager                       
                        }
                        setCurrentItem(tmp[i]);
                        break;
                      }
                    }
                  }
                  setItems(tmp);
                  setFilterItems(tmp);
                  
                  setSaving(false);
                  setEditFormVisible(false);
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setSaving(false);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setSaving(false);
          });

    }
    const editDialogFooter = function(){
        return (
            <GeneralDialogFooter onOkClick={()=>{saveItem()}} onCancelClick={()=>{closeEditDialog()}} saving={saving} />
        )
    }
    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "organizationCode") setOrganizationCode(val);
        else if(name === "schoolName") setSchoolName(val);
        else if(name === "searchText") setSearchText(val);
        else if(name === "province") setProvince(val);
        else if(name === "city") setCity(val);
        else if(name === "address") setAddress(val);
        else if(name === "maxStudent") setMaxStudent(val);
        else if(name === "agentCode"){
          if(val == null) setAgentCode(0);
          else if(val == "") setAgentCode(0);
          else setAgentCode(parseInt(val));
        }
    }
    
    const setRowActions = function(row) {
      if(isAgent) return (<></>);
        return (
            <Row className="justify-content-md-center" style={{}}>
              <Button icon="pi pi-pencil" rounded severity="success" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowEditClick(row)} title="ویرایش" />
              <Button icon="pi pi-trash" rounded severity="danger" style={{width:"45px", margin: "0px 3px", float:"right" }} onClick={() => onRowDeleteClick(row)} title="حذف" />
            </Row>
        );
    }
    const showSchoolState = function(row){
      if(row.school.isActive){
        return(
          <div style={{width:"20px", height:"20px", backgroundColor:"#44ee44", borderRadius:"50%"}}></div>
        )
      }
      else{
        return(
          <div style={{width:"20px", height:"20px", backgroundColor:"#ee4444", borderRadius:"50%"}}></div>
        )
      }
    }

    return(      
      <>   
      <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>لیست مدارس</div>
      <div style={{width:"calc(100% - 0px)", border:"1px solid #b0b0b0"}}>
        <Row style={{margin:"20px"}}>
          <Col md={2}>
              <FloatLabel>
                  <InputText value={searchText} onChange={(e)=>{onInputChange(e, "searchText")}}  keyfilter="" maxLength={100} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                  <label htmlFor="username">جستجو</label>
              </FloatLabel>

          </Col>
          <Col md={2} style={{padding:"10px 10px"}}>
              <div className="flex align-items-center" style={{marginTop:"0px", float:"right", height:"30px", overflow:"hidden"}}>
                  <Checkbox inputId={"chk_1"} onChange={(e)=>{setIncludeActive(e.checked)}} checked={includeActive} />
                  <label htmlFor={"chk_1"} className="ml-2"> &nbsp;مدارس فعال</label>
              </div>
          </Col>
          <Col md={2} style={{padding:"10px 10px"}}>
              <div className="flex align-items-center" style={{marginTop:"0px", float:"right", height:"30px", overflow:"hidden"}}>
                  <Checkbox inputId={"chk_2"} onChange={(e)=>{setIncludeInActive(e.checked)}} checked={includeInActive} />
                  <label htmlFor={"chk_2"} className="ml-2"> &nbsp;مدارس غیر فعال</label>
              </div>
          </Col>
          {
          isAgent?
          <></>
          :
          <Col md={2}>
              <FloatLabel>
                  <InputText value={agentCode} onChange={(e)=>{onInputChange(e, "agentCode")}}  keyfilter="int" maxLength={4} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                  <label htmlFor="username">کد نماینده</label>
              </FloatLabel>
          </Col>
          }
          <Col md={2} style={{padding:"5px 10px"}}>
              <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right", margin:"0px" }}>             
                <Button label="جستجو کن" icon="pi pi-search" onClick={()=>reloadData()} severity="secondary" iconPos="right" />
              </div>                

          </Col>
        </Row>
      </div>
      <div className="card" style={{overflow:"scroll", marginTop:"10px"}}>          
          {
            loading?
                    <DataTable value={LoadingRows}  className="p-datatable-striped">
                        <Column field="id" header="کد" style={{ width: '20%' }} body={<Skeleton />}></Column>
                        <Column field="title" header="عنوان" style={{ width: '80%' }} body={<Skeleton />}></Column>
                    </DataTable>
            :
              <>
                
                <DataTable value={filterItems} selectionMode={true ? null : 'radiobutton'} scrollable tableStyle={{ minWidth: '50rem' }} size="small" stripedRows paginator rows={50} rowsPerPageOptions={[50, 100, 200, 500]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                currentPageReportTemplate="{first} تا {last} از {totalRecords}"
                dataKey="id"  selection={currentItem}  onSelectionChange={(e) => {setCurrentItem(e.value)}}>
                        <Column selectionMode="single" headerStyle={{ width: '3rem' }}></Column>
                        <Column header="#" headerStyle={{ width: '3rem' }} body={(data, options) => options.rowIndex + 1}  className="list-cell-text-align"></Column>
                        {config.ShowListId? <Column field="id" header={"شناسه"} sortable className="list-cell-text-align"></Column>: <></>} 
                        <Column field="school.organizationCode" header={"کد"} sortable className="list-cell-text-align"></Column>
                        <Column field="school.schoolName" header={"نام"} sortable className="list-cell-text-align"></Column>
                        <Column field="school.province" header={"استان"} sortable className="list-cell-text-align"></Column>
                        <Column field="school.city" header={"شهر"} sortable className="list-cell-text-align"></Column>
                        <Column field="manager.lastname"  body={(row)=>"["+row.manager.mobile+"]" + row.manager.firstname + " " + row.manager.lastname} header={"مدیر"} sortable className="list-cell-text-align"></Column>
                        <Column field="registerdStudent"  header={"دانش آموز"} sortable className="list-cell-text-align"></Column>
                        <Column field="school.maxStudent" header={"حداکثر مجاز"} sortable className="list-cell-text-align"></Column>
                        <Column field="school.isActive" body={(row)=>showSchoolState(row)} sortable header={"وضعیت"} className="list-cell-text-align"></Column>
                        <Column field="school.agentCode" header={"کد نماینده"} sortable className="list-cell-text-align"></Column>
                        <Column body={(row) => setRowActions(row)} exportable={false} style={{ width:"100px" }}></Column>
                </DataTable>
                
              </>
          }           
       </div>
       {
        editFormVisible?
        <Dialog visible={true} style={{ width: '50rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }}
                    header="ثبت مشخصات مدرسه" modal className="p-fluid" footer={() => editDialogFooter()} onHide={() => closeEditDialog()}>
                      <table style={{width:"100%"}}>
                        <tbody>
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              <FloatLabel>
                                  <InputText value={organizationCode} onChange={(e)=>{onInputChange(e, "organizationCode")}}  keyfilter="int" maxLength={10} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                  <label htmlFor="username">کد مدرسه</label>
                              </FloatLabel>
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              <FloatLabel>
                                  <InputText value={schoolName} onChange={(e)=>{onInputChange(e, "schoolName")}}  keyfilter="" maxLength={100} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                  <label htmlFor="username">نام مدرسه</label>
                              </FloatLabel>
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr>
                          <tr>
                            <td style={{padding:"1px"}}>
                              <FloatLabel>
                                  <InputText value={province} onChange={(e)=>{onInputChange(e, "province")}}  keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                  <label htmlFor="username">استان</label>
                              </FloatLabel>
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr><tr>
                            <td style={{padding:"1px"}}>
                              <FloatLabel>
                                  <InputText value={city} onChange={(e)=>{onInputChange(e, "city")}}  keyfilter="" maxLength={50} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                  <label htmlFor="username">شهر</label>
                              </FloatLabel>
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr><tr>
                            <td style={{padding:"1px"}}>
                              <FloatLabel>
                                  <InputText value={address} onChange={(e)=>{onInputChange(e, "address")}}  keyfilter="" maxLength={150} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                  <label htmlFor="username">آدرس</label>
                              </FloatLabel>
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr><tr>
                            <td style={{padding:"1px"}}>
                              <FloatLabel>
                                  <InputText value={maxStudent} onChange={(e)=>{onInputChange(e, "maxStudent")}}  keyfilter="int" maxLength={4} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                  <label htmlFor="username">حداکثر دانش آموز</label>
                              </FloatLabel>
                            </td>
                          </tr>
                          <tr><td>&nbsp;</td></tr>
                        </tbody>
                      </table>

        </Dialog>
        :
        <></>
       }
      <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
      <ShowConfirm visible={confirmDeleteVisible} message="آیا از حذف مطمئن هستید؟" caption="اطمینان از حذف" onAccept={onDeleteConfirm_Accept} onReject={onDeleteConfirm_Reject} loading={deleting} />
      </>  
    );
}
